import { getBaseStore } from "@utils/configuration/aem";

import CreateApiModule from "@redux/create-api-module";

import { $PhonenumberPrefixesModuleName } from "./phonenumberPrefixes.types";

const { actions } = CreateApiModule(
    $PhonenumberPrefixesModuleName,
    () => `/i18nservice/${getBaseStore()}/i18n/phoneprefixes`,
);

export const clear = actions.clear;
export const load = actions.load;
export const refetch = actions.refetch;
